<template>
  <v-card>
    <v-card-title class="pr-2" :style=" { backgroundColor: colors.primary.hex }">
      <h2 style="color:white">Bedrijf toevoegen</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeAddCompDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert
      class="ma-0 pa-2"
      v-if="feedback"
      :value="true"
      type="warning"
    >
    {{ feedback }} 
    </v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="AddCompForm" v-model="valid" lazy-validation>
        <v-text-field
          class="pt-4"
          label="Bedrijfsnaam"
          v-model="newComp.name"
          :rules="requiredRules"
          prepend-inner-icon="account_box"
          :color="colors.primary.hex"
          :background-color="$vuetify.theme.themes[theme].menu"       
          hide-details
          required
          outlined
        ></v-text-field>
        <v-text-field
          class="pt-4"
          label="Email"
          v-model="newComp.email"
          :rules="emailRules"
          prepend-inner-icon="email"
          :color="colors.primary.hex"
          :background-color="$vuetify.theme.themes[theme].menu"       
          hide-details
          required
          outlined
        ></v-text-field>
         <v-text-field
          class="pt-4"
          label="Url"
          v-model="newComp.url"
          :rules="requiredRules"
          prepend-inner-icon="web"
          :color="colors.primary.hex"
          :background-color="$vuetify.theme.themes[theme].menu"       
          hide-details
          required
          outlined
        ></v-text-field>
        <v-select
          class="pt-4"
          v-model="newComp.languages"
          :items="languages"
          multiple
          label="Selecteer talen"
          item-text="name"
          item-value="code"
          prepend-inner-icon="flag"
          :rules="requiredRules"
          :color="colors.primary.hex"
          :item-color="colors.primary.hex"
          :background-color="$vuetify.theme.themes[theme].menu"       
          hide-details
          required
          outlined
        ></v-select>
        <v-select
          class="pt-4"
          v-model="newComp.packages"
          :items="packages"
          multiple
          label="Selecteer pakketten"
          item-text="name"
          chips
          item-value="id"
          prepend-inner-icon="lock"
          :rules="requiredRules"
          :color="colors.primary.hex"
          :item-color="colors.primary.hex"
          :background-color="$vuetify.theme.themes[theme].menu"       
          hide-details
          required
          outlined
        ></v-select>
        <div class="pa-3 my-4" :style="{backgroundColor: $vuetify.theme.themes[theme].menuborder}">
            <v-alert
              v-if="doublePackages.active"
              dense
              border="left"
              type="warning"
              >
              Er <span v-if="doublePackages.packages.length == 1">is</span> <span v-else>zijn</span> {{ doublePackages.packages.length }} pakket<span v-if="doublePackages.packages.length > 1">ten</span> aangeschaft en als trial ingesteld:
              <div v-for="(doublePackage, index) in doublePackages.packages" :key="index">
                <span v-for="(originalPackage, index) in packages" :key="index">
                  <span v-if="doublePackage == originalPackage.id"><strong> &#x2022; {{originalPackage.name}}</strong></span>
                </span>
              </div>
            </v-alert>
            <h2>Pakketten om te proberen</h2>
            <v-select
              class="pt-4"
              v-model="newComp.trials"
              :items="filteredPackages"
              multiple
              label="Trial pakketten"
              item-text="name"
              item-value="id"
              chips
              prepend-inner-icon="timelapse"
              :item-color="colors.primary.hex"
              :color="colors.primary.hex"
              :background-color="$vuetify.theme.themes[theme].menu"       
              hide-details
              return-object
              required
              outlined
            ></v-select>

            <div>
              <div v-for="(trailPackage, index) in newComp.trials" :key="index" class="py-1">
                <h3 class="py-2"><strong>{{ trailPackage.name }}</strong></h3>

                <v-container grid-list-md class="pa-0" fluid>
                  <v-layout row wrap>
                    <v-flex md6>
                      <v-menu
                        :close-on-content-click="false"
                        v-model="datePickerDialog[trailPackage.name]"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                        >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            outlined
                            style="max-width: 450px"
                            :color="colors.primary.hex"
                            v-on="on"
                            dense
                            :background-color="$vuetify.theme.themes[theme].menu"
                            v-model="trailPackage.trialStartDate"
                            label="Startdatum"
                            prepend-inner-icon="event"
                            readonly
                            hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="trailPackage.trialStartDate"
                          :color="colors.primary.hex"
                          no-title
                          @input="datePickerDialog[trailPackage.name] = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex md5>
                      <v-text-field
                        outlined
                        style="max-width: 450px"
                        :color="colors.primary.hex"
                        dense
                        :background-color="$vuetify.theme.themes[theme].menu"
                        v-model.number="trailPackage.trialDays"
                        label="Aantal dagen"
                        hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex md1>
                      <v-btn style="margin: 2px 0" icon :color="colors.primary.hex">
                        <v-icon @click="newComp.trials.splice(index, 1)">close</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </div>
            </div>
          </div>
          
        <v-select
          class="pt-4"
          v-model="newComp.type"
          :items="companyTypes"
          label="Type bedrijf"
          item-text="name"
          item-value="id"
          prepend-inner-icon="business_center"
          :rules="requiredRules"
          :color="colors.primary.hex"
          :item-color="colors.primary.hex"
          :background-color="$vuetify.theme.themes[theme].menu"       
          hide-details
          required
          outlined
        ></v-select>
        <div class="color-box-wrapper clear pt-4">
          <div class="color-boxes-icon">
            <v-icon>palette</v-icon>
          </div>
          <div class="color-boxes clear">
            <p class="ma-0">Selecteer primaire en secondaire kleur</p>
            <div class="color-box" v-bind:style="{ backgroundColor: colors.primary.hex }" @click="primaryColorDialog = true"></div>
            <div class="color-box" v-bind:style="{ backgroundColor: colors.secondary.hex}" @click="secondaryColorDialog = true"></div>
          </div>
        </div>

        <div class="upload-image-wrapper clear pt-4">
          <div class="upload-image-icon">
            <v-icon>image</v-icon>
          </div>
          <div class="upload-image">
            <p class="ma-0">Upload bedrijfslogo</p>
            <div v-if="filename" class="logo-upload-preview">
              <img :src="newComp.logoUrl">
              <div v-if="uploading == true" class="upload-bar">
                <p class="ma-0">{{ uploadProgress }} %</p>
                <div class="upload-bar-inner" v-bind:style="{ backgroundColor: colors.primary.hex, width: uploadProgress  + '%'  }"></div>
              </div>
            </div>
            <v-btn raised :color="colors.primary.hex" dark @click="onFileSelect">Kies afbeelding</v-btn>
            <input
              type="file"
              style="display: none;"
              ref="fileInput"
              accept="image/*"
              @change="onFilePicked">
          </div>
        </div>
        <div class="form-active-switch">
          <v-switch
            :color="colors.primary.hex"
            label="Actief"
            v-model="newComp.active"
          ></v-switch>
        </div>

      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeAddCompDialog()"
              >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              dark
              rounded
              :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
              :color="colors.secondary.hex"
              @click="addCompany()"
              >
              Bedrijf toevoegen
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
      
    <v-dialog width="225px" v-model="primaryColorDialog">
      <chrome-picker v-model="colors.primary"></chrome-picker>
    </v-dialog>

    <v-dialog width="225px" v-model="secondaryColorDialog">
      <chrome-picker v-model="colors.secondary"></chrome-picker>
    </v-dialog>
      
  </v-card>
</template>


<script>
import db from "../../firebase/init";
import firebase from "firebase/app";;
import { Chrome } from "vue-color";
import platform from 'platform'; 
import moment from 'moment';

export default {
  name: "add-comp-form",
  components: {
    "chrome-picker": Chrome
  },
  data() {
    return {
      valid: false,
      newComp: {
        logoUrl: null,
        active: true,
        languages: ["nl"],
        type: null,
        trials: [],
        packages: []
      },
      requiredRules: [v => !!v || "Dit veld is verplicht"],
      valid: true,
      filename: null,
      image: null,
      colors: {
        primary: {
          hex: "#5f1d9a"
        },
        secondary: {
          hex: "#e5007d"
        }
      },
      companyTypes: [
        {
          name: "Kapper",
          id: "hairsalon"
        },
        {
          name: "Anders",
          id: "other"
        }
      ],
      datePickerDialog:{},
      packages: [
        {
          name: "Reviews",
          id: "customerjourney",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        },
        {
          name: "Afspraakwidget",
          id: "conversion",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        }, 
        {
          name: "Call Center",
          id: "callcenter",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        },
        {
          name: "Barometers",
          id: "barometers",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        },
        {
          name: "Dossier",
          id: "dossier",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        },
        {
          name: "Dossier Foto's",
          id: "dossierphotos",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        },
        {
          name: "Narrowcasting",
          id: "narrowcasting",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        },
        {
          name: "Adwords",
          id: "adwords",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        },
        {
          name: "Nieuwsbrieven",
          id: "newsletters",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        },
        {
          name: "Website",
          id: "website",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        },
        {
          name: "SMS",
          id: "sms",
          trialDays: 30,
          trialStartDate: moment().format("YYYY-MM-DD")
        }
      ],
      primaryColorDialog: false,
      secondaryColorDialog: false,
      languages: [
        {
          code: "nl",
          name: "Nederlands"
        },
        {
          code: "en",
          name: "Engels"
        }
      ],
      emailRules: [
        v => !!v || "E-mail is verplicht",
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
      ],
      feedback: null,
      recordId: null,
      uploading: false,
      uploadProgress: null,
      file: {}
    };
  },

  methods: {
    closeAddCompDialog() {
      this.$emit("newCompDialogChange", false);
      this.feedback = null;
      this.colors =  {
        primary: {
          hex: "#5f1d9a"
        },
        secondary: {
          hex: "#e5007d"
        }
      }
    },

    onFileSelect() {
      this.$refs.fileInput.click();
    },

    onFilePicked(event) {
      const files = event.target.files;
      this.file = files[0];
      let filename = files[0].name;
      this.filename = filename;
      console.log("files: " + filename);
      if (filename.lastIndexOf(".") <= 0) {
        this.feedback = "Voeg een geldig bestand toe.";
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.newComp.logoUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.image = files[0];
      this.feedback = null;
    },

    addCompany() {
      if (this.$refs.AddCompForm.validate()) {
        let compName = this.newComp.name;
        let compNameLower = compName.toLowerCase();
        let compNameLowerNoSpecial = compNameLower.replace(/[!@#$%^&*+()"';:.,]+/g, "");
        this.newComp.id = compNameLowerNoSpecial.replace(/\s+/g, "");

        db.collection("companies")
          .doc(this.newComp.id)
          .set({
            // Basic Company Settings
            active: this.newComp.active,
            name: this.newComp.name,
            email: this.newComp.email,
            url: this.newComp.url,
            logoUrl: null,
            colors: this.colors,
            packages: this.newComp.packages,
            type: this.newComp.type,
            languages: this.newComp.languages,
            trials: this.newComp.trials,

            // Journey & Email Settings
            journeys: {},

            directFeedback: false,
            directFeedbackScore: 2,
            directFeedbackMailto: this.newComp.email,
            directFeedbackMailFrom: this.newComp.email,
            surveyFeedbackAsk: 4,
            
            ratingView: "smileys",
            sendRestriction: false,
            sendRestrictionTime: "6",
            surveyResponseTime: "14",
            emailSubject: {
              nl: "Wij zijn benieuwd naar uw mening.",
              en: "We would like to know your opinion."
            },
            widget: {},
            receipt: {
              sendReceipt: false,
              sendReceiptJourney: false,
              emailFooter: "",
              emailIntro: {
                female: "",
                male: "",
                other: ""
              },
              logoInvoice: "",
              logoInvoiceScale: {
                height: null,
                width: null,
                x: null,
                y: null
              },
              promotions: []
            },
            emailIntro: {
              nl:
                "Hartelijk dank voor uw komst bij " +
                this.newComp.name +
                ". Wij zijn benieuwd naar uw mening over de door ons geleverde diensten. Daarom willen we u graag één vraag stellen.",
              en:
                "Thank you for visiting " +
                this.newComp.name +
                ". We are curious what your opinion is about the services we provided. Therefore we would like to ask you one question"
            },

            pageIntro: {
              nl:
                "Hartelijk dank voor het beantwoorden van deze vraag. " +
                this.newComp.name +
                " staat altijd open voor verbeteringen. Uw mening is voor ons erg waardevol.",
              en:
                "Thank you for answering this question. " +
                this.newComp.name +
                " is always openminded for improvements. Your opinion is very important to us."
            },

            pageAspects: {
              nl: "Hieronder bevinden zich nog een aantal aspecten waar wij graag uw mening over willen weten.",
              en: "Right below are some aspects that we would like to know your opinion about."
            },

            // Company API Settings
            apiActive: false,
            apiItems: {
              drupal: false,
              salonhub: false
            },
            conversion: {
              adwordsBudget: null,
              callcenter: {
                callModule: false,
                hogansFirst: false,
                twilioNumber: null,
              },
              sources: [],
              start: null,
              salonhubSettings: {
                policy: {
                  en: "Hogans, gevestigd aan Parijsboulevard 209, 3541 CS UTRECHT, is verantwoordelijk voor de verwerking van deze persoonsgegevens zoals weergegeven in deze privacyverklaring. Contactgegevens: https://www.hogans-agency.nl Parijsboulevard 209, 3541 CS UTRECHT +31 (0) 85 020 74 22 De Functionaris Gegevensbescherming van Hogans is bereikbaar via info@hogans.nl Persoonsgegevens die wij verwerken Hogans verwerkt uw persoonsgegevens doordat u gebruik maakt van onze diensten en/of omdat u deze zelf aan ons verstrekt. Hieronder vindt u een overzicht van de persoonsgegevens die wij verwerken: - Voor- en achternaam - Geslacht - Telefoonnummer - E-mailadres - IP-adres - Locatiegegevens - Internetbrowser en apparaat type Bijzondere en/of gevoelige persoonsgegevens die wij verwerken Deze applicatie heeft niet de intentie gegevens te verzamelen over websitebezoekers die jonger zijn dan 16 jaar. Tenzij ze toestemming hebben van ouders of voogd. We kunnen echter niet controleren of een bezoeker ouder dan 16 is. Wij raden ouders dan ook aan betrokken te zijn bij de online activiteiten van hun kinderen, om zo te voorkomen dat er gegevens over kinderen verzameld worden zonder ouderlijke toestemming. Als u er van overtuigd bent dat wij zonder die toestemming persoonlijke gegevens hebben verzameld over een minderjarige, neem dan contact met ons op via info@hogans.nl, dan verwijderen wij deze informatie. Met welk doel en op basis van welke grondslag wij persoonsgegevens verwerken Hogans verwerkt uw persoonsgegevens voor de volgende doelen: U te kunnen bellen of e-mailen indien dit nodig is om de dienstverlening van onze klanten (beter) uit te kunnen voeren Hogans AgencyHogans Agency Digitale successen met Hogans Agency Digitale oplossingen voor elk platform. Kennis van zaken en passie voor ons werk. Dat is Hogans Agency.(1 kB) https://e7h3v8y3.stackpathcdn.com/wp-content/uploads/2020/01/hogans-voip-1.png 11:07 - U te informeren over wijzigingen van diensten en producten van onze klanten - U de mogelijkheid te bieden een account aan te maken - Hogans analyseert uw gedrag op de website om daarmee de website te verbeteren en het aanbod van producten en diensten af te stemmen op uw voorkeuren.  Hoe lang we persoonsgegevens bewaren Hogans bewaart uw persoonsgegevens niet langer dan strikt nodig is om de doelen te realiseren waarvoor uw gegevens worden verzameld. Wij hanteren de volgende bewaartermijnen voor de volgende (categorieën) van persoonsgegevens: Persoonsgegevens > 2 jaar > mogelijkheid tot analyse en verbetering dienstverlening              Delen van persoonsgegevens met derden Hogans verstrekt uitsluitend aan derden en alleen als dit nodig is voor de uitvoering van onze overeenkomst met u of om te voldoen aan een wettelijke verplichting.  Cookies, of vergelijkbare technieken, die wij gebruiken Hogans gebruikt geen cookies of vergelijkbare technieken. Gegevens inzien, aanpassen of verwijderen  U heeft het recht om uw persoonsgegevens in te zien, te corrigeren of te verwijderen. Daarnaast heeft u het recht om uw eventuele toestemming voor de gegevensverwerking in te trekken of bezwaar te maken tegen de verwerking van uw persoonsgegevens door Hogans en heeft u het recht op gegevensoverdraagbaarheid. Dat betekent dat u bij ons een verzoek kunt indienen om de persoonsgegevens die wij van u beschikken in een computerbestand naar u of een ander, door u genoemde organisatie, te sturen. U kunt een verzoek tot inzage, correctie, verwijdering, gegevensoverdraging van uw persoonsgegevens of verzoek tot intrekking van uw toestemming of bezwaar op de verwerking van uw persoonsgegevens sturen naar info@hogans.nl. Om er zeker van te zijn dat het verzoek tot inzage door u is gedaan, vragen wij u een kopie van uw identiteitsbewijs met het verzoek mee te sturen. Maak in deze kopie uw pasfoto, MRZ (machine readable zone, de strook met nummers onderaan het paspoort), paspoortnummer en Burgerservicenummer (BSN) zwart. Dit ter bescherming van uw privacy. We reageren zo snel mogelijk, maar binnen vier weken, op uw verzoek. Hogans wil u er tevens op wijzen dat u de mogelijkheid heeft om een klacht in te dienen bij de nationale toezichthouder, de Autoriteit Persoonsgegevens. Dat kan via de volgende link: https://autoriteitpersoonsgegevens.nl/nl/contact-met-de-autoriteit-persoonsgegevens/tip-ons Hoe wij persoonsgegevens beveiligen Hogans neemt de bescherming van uw gegevens serieus en neemt passende maatregelen om misbruik, verlies, onbevoegde toegang, ongewenste openbaarmaking en ongeoorloofde wijziging tegen te gaan. Als u de indruk heeft dat uw gegevens niet goed beveiligd zijn of er aanwijzingen zijn van misbruik, neem dan contact op met onze klantenservice of via info@hogans.nl",
                  nl: "Hogans, gevestigd aan Parijsboulevard 209, 3541 CS UTRECHT, is verantwoordelijk voor de verwerking van deze persoonsgegevens zoals weergegeven in deze privacyverklaring. Contactgegevens: https://www.hogans-agency.nl Parijsboulevard 209, 3541 CS UTRECHT +31 (0) 85 020 74 22 De Functionaris Gegevensbescherming van Hogans is bereikbaar via info@hogans.nl Persoonsgegevens die wij verwerken Hogans verwerkt uw persoonsgegevens doordat u gebruik maakt van onze diensten en/of omdat u deze zelf aan ons verstrekt. Hieronder vindt u een overzicht van de persoonsgegevens die wij verwerken: - Voor- en achternaam - Geslacht - Telefoonnummer - E-mailadres - IP-adres - Locatiegegevens - Internetbrowser en apparaat type Bijzondere en/of gevoelige persoonsgegevens die wij verwerken Deze applicatie heeft niet de intentie gegevens te verzamelen over websitebezoekers die jonger zijn dan 16 jaar. Tenzij ze toestemming hebben van ouders of voogd. We kunnen echter niet controleren of een bezoeker ouder dan 16 is. Wij raden ouders dan ook aan betrokken te zijn bij de online activiteiten van hun kinderen, om zo te voorkomen dat er gegevens over kinderen verzameld worden zonder ouderlijke toestemming. Als u er van overtuigd bent dat wij zonder die toestemming persoonlijke gegevens hebben verzameld over een minderjarige, neem dan contact met ons op via info@hogans.nl, dan verwijderen wij deze informatie. Met welk doel en op basis van welke grondslag wij persoonsgegevens verwerken Hogans verwerkt uw persoonsgegevens voor de volgende doelen: U te kunnen bellen of e-mailen indien dit nodig is om de dienstverlening van onze klanten (beter) uit te kunnen voeren Hogans AgencyHogans Agency Digitale successen met Hogans Agency Digitale oplossingen voor elk platform. Kennis van zaken en passie voor ons werk. Dat is Hogans Agency.(1 kB) https://e7h3v8y3.stackpathcdn.com/wp-content/uploads/2020/01/hogans-voip-1.png 11:07 - U te informeren over wijzigingen van diensten en producten van onze klanten - U de mogelijkheid te bieden een account aan te maken - Hogans analyseert uw gedrag op de website om daarmee de website te verbeteren en het aanbod van producten en diensten af te stemmen op uw voorkeuren.  Hoe lang we persoonsgegevens bewaren Hogans bewaart uw persoonsgegevens niet langer dan strikt nodig is om de doelen te realiseren waarvoor uw gegevens worden verzameld. Wij hanteren de volgende bewaartermijnen voor de volgende (categorieën) van persoonsgegevens: Persoonsgegevens > 2 jaar > mogelijkheid tot analyse en verbetering dienstverlening              Delen van persoonsgegevens met derden Hogans verstrekt uitsluitend aan derden en alleen als dit nodig is voor de uitvoering van onze overeenkomst met u of om te voldoen aan een wettelijke verplichting.  Cookies, of vergelijkbare technieken, die wij gebruiken Hogans gebruikt geen cookies of vergelijkbare technieken. Gegevens inzien, aanpassen of verwijderen  U heeft het recht om uw persoonsgegevens in te zien, te corrigeren of te verwijderen. Daarnaast heeft u het recht om uw eventuele toestemming voor de gegevensverwerking in te trekken of bezwaar te maken tegen de verwerking van uw persoonsgegevens door Hogans en heeft u het recht op gegevensoverdraagbaarheid. Dat betekent dat u bij ons een verzoek kunt indienen om de persoonsgegevens die wij van u beschikken in een computerbestand naar u of een ander, door u genoemde organisatie, te sturen. U kunt een verzoek tot inzage, correctie, verwijdering, gegevensoverdraging van uw persoonsgegevens of verzoek tot intrekking van uw toestemming of bezwaar op de verwerking van uw persoonsgegevens sturen naar info@hogans.nl. Om er zeker van te zijn dat het verzoek tot inzage door u is gedaan, vragen wij u een kopie van uw identiteitsbewijs met het verzoek mee te sturen. Maak in deze kopie uw pasfoto, MRZ (machine readable zone, de strook met nummers onderaan het paspoort), paspoortnummer en Burgerservicenummer (BSN) zwart. Dit ter bescherming van uw privacy. We reageren zo snel mogelijk, maar binnen vier weken, op uw verzoek. Hogans wil u er tevens op wijzen dat u de mogelijkheid heeft om een klacht in te dienen bij de nationale toezichthouder, de Autoriteit Persoonsgegevens. Dat kan via de volgende link: https://autoriteitpersoonsgegevens.nl/nl/contact-met-de-autoriteit-persoonsgegevens/tip-ons Hoe wij persoonsgegevens beveiligen Hogans neemt de bescherming van uw gegevens serieus en neemt passende maatregelen om misbruik, verlies, onbevoegde toegang, ongewenste openbaarmaking en ongeoorloofde wijziging tegen te gaan. Als u de indruk heeft dat uw gegevens niet goed beveiligd zijn of er aanwijzingen zijn van misbruik, neem dan contact op met onze klantenservice of via info@hogans.nl"
                },
                succesUrl: this.newComp.url,
                enableConfirmationEmail: false,
                separateConfirmationEmailNewClient: false,
                confirmationEmail: {
                  emailSubject: {
                    nl: "",
                    en:" "
                  },
                  emailContent: {
                    nl: "",
                    en:" "
                  }, 
                },
                confirmationEmailNewClients: {
                  emailSubject: {
                    nl: "",
                    en:" "
                  },
                  emailContent: {
                    nl: "",
                    en:" "
                  }, 
                }
              },
              feedBackOnClose: true,
              showCallback: false,
              smsSettings: {
                callUsText: {
                  en: "",
                  nl: ""
                },
                senderID: "",
                smsOnClose: false,
              }
            },
            benchmarkEmployees: {},
            barometersSettings: {
              dataView: "fourweeks",
              showAllround: false,
              showHourrateAmmount: false,
              showCreativeBarometer: false,
              showMonthBarometer: false,
              showWeekGoalBarometer: false,
              showWeekGoalTreatmentsBarometer: false,
              showWeekGoalProductsBarometer: false,
              showWeekGoalColorsBarometer: false
            },
            salonhubApiSettings: {
              customer: null,
              username: null,
              password: null,
              md5: null,
              salons: null
            },

            // Company Social Settings
            social: {
              facebook: false,
              instagram: false,
              twitter: false,
              pinterest: false,
              googleplus: false,
              facebookUrl: null,
              instagramUrl: null,
              twitterUrl: null,
              pinterestUrl: null,
              googleplusUrl: null
            }
          })
          .then(async () => {
            if (this.filename) {
              await this.uploadCompanyLogo();
            }
          })
          .then(() => {
            db.collection("log").add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              software: String(platform.os),
              browser: platform.name + ' ' + platform.version, 
              pillarrrVersion: this.$store.state.version,
              action: "Bedrijf toegevoegd: " + this.newComp.name,
              extra:
                "<b>Active</b>: " +
                this.newComp.active +
                "<br>" +
                "<b>Naam</b>: " +
                this.newComp.name +
                "<br>" +
                "<b>E-mail</b>: " +
                this.newComp.email +
                "<br>" +
                "<b>Url</b>: " +
                this.newComp.url
            });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeAddCompDialog();
            console.log("Company succesfully added");
            
          })
          .catch(error => {
            console.error("Error adding Company: ", error);
            db.collection("log").add({
              time: new Date(),
              logType: "error",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Error adding Company: " + this.activeCompName,
              software: String(platform.os),
              browser: platform.name + ' ' + platform.version, 
              pillarrrVersion: this.$store.state.version,
              extra: JSON.stringify(error)
            });
          });
      } else {
        this.feedback = "Vul alle velden in om een bedrijf toe te voegen.";
      }
    },

    uploadCompanyLogo() {
      return new Promise((resolve, reject) => {
        console.log("start storen");
        const file = this.file;
        const filename = this.filename;
        const ext = filename.slice(filename.lastIndexOf("."));
        const fileUrl = this.newComp.id + "/" + "logo/" + this.newComp.id + "-logo" + ext;
        this.uploading = true;
        let uploadTask = firebase
          .storage()
          .ref(fileUrl)
          .put(file);

        uploadTask.on(
          "state_changed",
          taskSnapshot => {
            var progress = Math.ceil((taskSnapshot.bytesTransferred / taskSnapshot.totalBytes) * 100);
            this.uploadProgress = progress;
          },
          error => {
            console.log(error);
            reject();
          },
          () => {
            console.log("The upload is compleet");
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(url => {
                db.collection("companies")
                  .doc(this.newComp.id)
                  .update({
                    logoUrl: url
                  })
                  .then(() => {
                    resolve();
                    this.uploading = false;
                    this.uploadProgress = null;
                  })
                  .catch(error => {
                    reject();
                    this.uploading = false;
                    this.uploadProgress = null;
                  });
              })
              .catch(error => {
                reject();
                this.uploading = false;
                this.uploadProgress = null;
              });
          }
        );
      });
    }
  },
  computed: {
    filteredPackages() {
      let packagesForTrial = []
      this.packages.forEach(availablePackage => {
        if((_.indexOf(this.newComp.packages, availablePackage.id) == -1) || (_.findIndex(this.newComp.trials, {'id': availablePackage.id}) >= 0)){
          packagesForTrial.push(availablePackage)
        }
      })
      return packagesForTrial;
    },

    doublePackages() {
      let doublePackages = {
        active: false,
        packages: []
      }
      if(this.newComp.packages && this.newComp.packages.length > 0){
        this.newComp.packages.forEach(selectedPackage => {
          this.newComp.trials.forEach(trialPackage => {
            if(selectedPackage == trialPackage.id){
              doublePackages.active = true;
              doublePackages.packages.push(selectedPackage);
            }
          })
        })
        if(doublePackages.length > 0){
          return doublePackages;
        }
        else{
          return doublePackages;
        }
      }
      else{
        return doublePackages;
      }
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    }
  }
};
</script>
